export const DOMAIN = 'ProgressReviewWidget';
